import { render, staticRenderFns } from "./add_promotion.vue?vue&type=template&id=4c9bbe4e"
import script from "./add_promotion.vue?vue&type=script&lang=js"
export * from "./add_promotion.vue?vue&type=script&lang=js"
import style0 from "./add_promotion.vue?vue&type=style&index=0&id=4c9bbe4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports